import {SpacersController} from "./controllers/SpacersController";
import {HandlesController} from "./controllers/HandlesController";
import {WallsController} from "./controllers/WallsController";
import {ShapeColorsController} from "./controllers/ShapeColorsController";
import {WaterfallController} from "./controllers/line/WaterfallController";
import {RemovedFeaturesController} from "./controllers/RemovedFeaturesController";
import {SnappedShapeGroupsController} from "./controllers/SnappedShapeGroupsController";
import {SelectedShapesController} from "./controllers/SelectedShapesController";
import {CrownMoldingController} from "./controllers/line/CrownMoldingController";
import {Images3dController} from "./controllers/Images3dController";
import {HingesController} from "./controllers/HingesController";
import {WORKSPACE_RESOURCES} from "../../../constants";
import {Images3dAutoSavedController} from "./controllers/Images3dAutoSavedController";

export const groupedDataInControllers = [
  WORKSPACE_RESOURCES.hinge
]

export const QUANTITY_GROUP = {
  doors: "doors",
  drawers: "drawers",
}

export const controllersConfig = {
  exportableControllers: [
    'walls',
    'snappedShapeGroups',
    'handles',
    WORKSPACE_RESOURCES.hinge,
  ],
};

export const WORKSPACE_CONTROLLERS_THAT_WILL_AUTO_ADD_FEATURES = [
  //WORKSPACE_RESOURCES.handles
  WORKSPACE_RESOURCES.hinge
]

export const WORKSPACE_CONTROLLERS_THAT_ADDS_FEATURES = [
  WORKSPACE_RESOURCES.handles,
  WORKSPACE_RESOURCES.hinge,
  WORKSPACE_RESOURCES.crownMolding,
  WORKSPACE_RESOURCES.waterfall,
]

const workspaceControllers = {
  walls: new WallsController(),
  crownMolding: new CrownMoldingController(),
  spacer: new SpacersController(),
  handles: new HandlesController(),
  hinge: new HingesController(),
  shapeColors: new ShapeColorsController(),
  waterfall: new WaterfallController(),
  removedFeatures: new RemovedFeaturesController(),
  snappedShapeGroups: new SnappedShapeGroupsController(),
  selectedShapes: new SelectedShapesController(),
  images3d: new Images3dController(),
  images3dAutoSaved: new Images3dAutoSavedController(),
};

export const getControllersExportData = () => {
  const exportData = {};
  controllersConfig.exportableControllers.forEach(controllerName => {
    const controller = workspaceControllers[controllerName];
    if (controller && typeof controller.exportData === 'function') {
      exportData[controllerName] = controller.exportData();
    }
  });

  return exportData;
};

export const importControllersData = (data) => {
  if (data) {
    Object.keys(data).forEach(controllerName => {
      const controller = workspaceControllers[controllerName];
      if (controller && typeof controller.importData === 'function') {
        controller.importData(data[controllerName]);
      }
    });
  }
};

export default workspaceControllers
